import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { CampoAggiuntivo, CampoUtility } from "../models/campo-aggiuntivo";
import { DynamicCrudService } from "../_services/dynamic-crud.service";
import { environment } from 'src/environments/environment';
import { FileStoreService } from '../_services/file-store.service';

@Component({
    templateUrl: './dynamic-edit.component.html'
})
export class DynamicEditComponent implements OnInit {
  environment = environment;
  @Input() DropdownSources: any = {};
  @Input() IsModal: boolean = true;
  @Input() ExternalAdd: boolean = false;
  @Input() FromLista: boolean = false;
  @Input() Item: any ={};
  @Input() CrudSettings: any;
  @Output() updated = new EventEmitter<Task>();
  Stampe: any;
  Refreshing: boolean = false;
  constructor(
      private ngbActiveModal: NgbActiveModal,
      public campoUtility: CampoUtility,
      private crudService: DynamicCrudService,
      private filestore: FileStoreService,
  ){}

  ngOnInit(): void {
      this.Refresh();
  }
    
  Refresh(){ 
    this.Refreshing = true;
    if(this.Item?.id) 
      this.crudService.GetItem(this.CrudSettings, {id: this.Item?.id}).subscribe(data=>{
        this.SetData(this.CrudSettings.GetResponseHasData ? data.data : {data: data})
      })
    else 
      this.SetData(this.Item ?? {})
  }

  SetData(data){
    this.Item = data.data;
    this.Stampe = data?.stampe;
    this.crudService.InitObject(this.Item, this.CrudSettings);
    this.FormBuilder();
    if(this.Item.id){
      this.filestore.SetListaFile(this.Item.files);
      this.filestore.SelectSection(this.CrudSettings.RestRoute);
    }
    setTimeout(() => {
      this.Refreshing = false;
    }, 100)
  }

  FormBuilder(){

    this.CrudSettings?.sezioni?.forEach(sezione=>{
      sezione.campi?.forEach(campo=>{
        this.SetCampoSource(this.Item, campo);
      })
    });

    this.CrudSettings?.campi?.forEach(campo=>{
        this.SetCampoSource(this.Item, campo);
    })

  }
  

  save(close?: boolean) {
    this.crudService.Save(this.Item, this.CrudSettings, close, this.ExternalAdd, (saved)=>{
      console.info("Saved: ", {
        Response: saved,
        Item: this.Item,
        Settings:this.CrudSettings,
        close: close, 
        ExternalAdd: this.ExternalAdd
      })
      this.saved(saved.Item, saved.close)
    })
  }

  saved(data, close?:boolean){
    this.Item.id = data.id;
    this.updated.emit(this.Item);
    this.Refresh();
    if (close)
      this.close();
  }

  onFileChanged() {
    this.Refresh();
  }

  ChangeHandler(item: { OnChange: string; Event: any, CampoAggiuntivo?: CampoAggiuntivo }) {
    console.log("Changehandler: ", item);
    switch (item.OnChange ) {

    }
  }

  getparam(oggetto, param){
    return oggetto ? oggetto[param]: null;
  }

  customButton(selected, button) {
    this.crudService.CustomButtonClick(this.Item, button, false, this.CrudSettings,(x)=>{this.updated.emit(x)}, (x)=>{this.saved(x, button.close);}, (x)=>{this.close();} );
  }

  FilterHandler($event: {OnFilter: string; Event: any}) {

  }

  SetCampoSource(item, campo){
    
  }

  close(){
    this.ngbActiveModal.dismiss();
  }
      
}